import { DATA_STYLE, HEADER_STYLE } from "../excelReportStyles";
import {
  addBordersToSheet,
  emptyValueFormatterForExcel,
  formatPlantTrainName,
} from "../excelReportUtils";

import { capitalize } from "../../../../utils/appUtils";
import {
  formatCipSequenceValue,
  typeFormatter,
} from "../../../../utils/tableDataFormatter";

export const createBenchmarkCIPSummarySheet = (sheet, plants, t) => {
  const allCIPEvents = [];

  plants.forEach((plant) => {
    if (plant?.trains && Array.isArray(plant.trains)) {
      plant.trains.forEach((train) => {
        if (train?.historic_cips && Array.isArray(train.historic_cips)) {
          train.historic_cips.forEach((cip) => {
            allCIPEvents.push({
              ...cip,
              plant_id: plant.plant_id,
              plant_name: plant.plant_name,
              train_num: train.train_num,
              project_name: formatPlantTrainName(
                plant.plant_name,
                plant.plant_id,
                train.train_num,
              ),
            });
          });
        }
      });
    }
  });

  allCIPEvents.sort((a, b) => {
    if (a.plant_id !== b.plant_id) return a.plant_id - b.plant_id;
    if (a.train_num !== b.train_num) return a.train_num - b.train_num;
    return new Date(b.start_date) - new Date(a.start_date);
  });

  const headers = [
    t("benchMark.headers.plantName"),
    t("benchMark.headers.startDate"),
    t("benchMark.headers.endDate"),
    t("benchMark.headers.type"),
    t("benchMark.headers.cipSequence"),
    t("benchMark.headers.source"),
    t("benchMark.headers.alkaliChemical"),
    t("benchMark.headers.alkaliPrice"),
    t("benchMark.headers.alkaliUsedPerCIP"),
    t("benchMark.headers.alkaliCIPPH"),
    t("benchMark.headers.alkaliCIPTemp"),
    t("benchMark.headers.alkaliCIPDuration"),
    t("benchMark.headers.alkaliAdditiveChemical"),
    t("benchMark.headers.alkaliAdditivePrice"),
    t("benchMark.headers.alkaliAdditiveUsedPerCIP"),
    t("benchMark.headers.alkaliAdditiveCIPPH"),
    t("benchMark.headers.alkaliAdditiveCIPTemp"),
    t("benchMark.headers.alkaliAdditiveCIPDuration"),
    t("benchMark.headers.acidChemical"),
    t("benchMark.headers.acidPrice"),
    t("benchMark.headers.acidUsedPerCIP"),
    t("benchMark.headers.acidCIPPH"),
    t("benchMark.headers.acidCIPTemp"),
    t("benchMark.headers.acidCIPDuration"),
    t("benchMark.headers.acidAdditiveChemical"),
    t("benchMark.headers.acidAdditivePrice"),
    t("benchMark.headers.acidAdditiveUsedPerCIP"),
    t("benchMark.headers.acidAdditiveCIPPH"),
    t("benchMark.headers.acidAdditiveCIPTemp"),
    t("benchMark.headers.acidAdditiveCIPDuration"),
    t("benchMark.headers.additionalInformation"),
  ];

  const headerRow = sheet.getRow(1);
  headers.forEach((header, idx) => {
    const cell = headerRow.getCell(idx + 1);
    cell.value = header;
    Object.assign(cell, HEADER_STYLE);
  });
  headerRow.commit();

  allCIPEvents.forEach((cip, idx) => {
    const row = sheet.getRow(2 + idx);
    const values = [
      emptyValueFormatterForExcel(cip.project_name),
      emptyValueFormatterForExcel(cip.start_date),
      emptyValueFormatterForExcel(cip.end_date),
      typeFormatter({ value: cip.type }, t) || "-",
      emptyValueFormatterForExcel(formatCipSequenceValue(cip.cip_sequence)),
      capitalize(cip.source) || "-",
      emptyValueFormatterForExcel(cip.alkali_chemical_name),
      emptyValueFormatterForExcel(cip.alkali_price),
      emptyValueFormatterForExcel(cip.alkali_used_per_cip),
      emptyValueFormatterForExcel(cip.alkali_cip_ph),
      emptyValueFormatterForExcel(cip.alkali_cip_temp),
      emptyValueFormatterForExcel(cip.alkali_cip_duration),
      emptyValueFormatterForExcel(cip.additive_alkali_chemical_name),
      emptyValueFormatterForExcel(cip.additive_alkali_price),
      emptyValueFormatterForExcel(cip.additive_alkali_used_per_cip),
      emptyValueFormatterForExcel(cip.additive_alkali_ph),
      emptyValueFormatterForExcel(cip.additive_alkali_temp),
      emptyValueFormatterForExcel(cip.additive_alkali_duration),
      emptyValueFormatterForExcel(cip.acid_chemical_name),
      emptyValueFormatterForExcel(cip.acid_price),
      emptyValueFormatterForExcel(cip.acid_used_per_cip),
      emptyValueFormatterForExcel(cip.acid_cip_ph),
      emptyValueFormatterForExcel(cip.acid_cip_temp),
      emptyValueFormatterForExcel(cip.acid_cip_duration),
      emptyValueFormatterForExcel(cip.additive_acid_chemical_name),
      emptyValueFormatterForExcel(cip.additive_acid_price),
      emptyValueFormatterForExcel(cip.additive_acid_used_per_cip),
      emptyValueFormatterForExcel(cip.additive_acid_ph),
      emptyValueFormatterForExcel(cip.additive_acid_temp),
      emptyValueFormatterForExcel(cip.additive_acid_duration),
      emptyValueFormatterForExcel(cip.additional_information),
    ];

    values.forEach((value, valueIdx) => {
      const cell = row.getCell(valueIdx + 1);
      cell.value = value;
      Object.assign(cell, DATA_STYLE);
    });

    row.commit();
  });

  sheet.getColumn(1).width = 35;
  sheet.getColumn(2).width = 12;
  sheet.getColumn(3).width = 12;
  sheet.getColumn(4).width = 12;
  sheet.getColumn(5).width = 14;
  sheet.getColumn(6).width = 12;
  for (let i = 7; i <= 30; i++) {
    sheet.getColumn(i).width = 14;
  }

  addBordersToSheet(sheet);
};
